import { Helmet } from 'react-helmet-async';
import { useLocales } from 'src/locales';
import CompetitorsMonitoring from 'src/sections/overview/dashboards/views/competitorsMonitoring';

// ----------------------------------------------------------------------

export default function Home() {
  const { t } = useLocales()
  return (
    <>
      <Helmet>
        <title>{t('competitorsMonitoring')}</title>
      </Helmet>

      <CompetitorsMonitoring />
    </>
  );
}
